import { Link } from 'react-router-dom';
import { Button } from '../../../../../../components/button/button';
import { Loader } from '../../../../../../components/loader/loader';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { buildParams, concatPath } from '../../../../../../helpers/path';
import { ManagerPath, RootPath, TasksPath } from '../../../../../../routes/manager/manager-enums';
import s from './delete-employee-modal.module.css';
import { useDeleteEmployeeModal } from './use-delete-employee-modal';

export const DeleteEmployeeModal = (props: ModalProps) => {
  const {
    t,
    handleConfirm,
    isLoading,
    isLoadingFetch,
    employeeActiveTasks,
    employeeName,
    schedulerList,
    employee,
    path,
  } = useDeleteEmployeeModal(props);

  return (
    <Modal {...props} className={s.feature} title={t('Удаление сотрудника') + ` ${employeeName}`}>
      {isLoadingFetch ? (
        <Loader />
      ) : (
        <div className={s.tasks}>
          <span className={s.pair}>
            {t('Имеются незавершенные задачи, продолжить удаление?', {
              number: employeeActiveTasks?.length || 0,
            })}
            <Link
              to={concatPath([
                RootPath.Manager,
                ManagerPath.Tasks,
                path || '',
                buildParams({ employee: employeeName }),
              ])}
              target="_blank"
            >
              {t('Просмотреть')}
            </Link>
          </span>
          <span className={s.pair}>
            {t('Имеются запланированные задачи, продолжить удаление?', {
              number: schedulerList?.length || 0,
            })}
            <Link
              to={concatPath([
                RootPath.Manager,
                ManagerPath.Tasks,
                TasksPath.Planner,
                buildParams({ staffIds: [employee?.id], modalId: 'schedulerList' }),
              ])}
              target="_blank"
            >
              {t('Просмотреть')}
            </Link>
          </span>
        </div>
      )}
      <div className={s.controls}>
        <Button onClick={props.onClose} disabled={isLoading} variant="secondary">
          {t('Отменить')}
        </Button>
        <Button onClick={handleConfirm} disabled={isLoading} variant="danger">
          {t('Удалить')}
        </Button>
      </div>
    </Modal>
  );
};
